// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import '@/assets/css/style.css'
import App from './App'
import router from './router'
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(vueSwiper)
import './assets/font/font.css'
import store from './store/index.js'
import '@/permission' // permission control

import VueQuillEditor from 'vue-quill-editor'
// 引入相关css
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

let language = 'en-us'
const i18n = new VueI18n({
	locale: language, // 默认语言
	fallbackLocale: language, // 如果当前语言没有在 locale 对象中找到，则使用 fallbackLocale 作为备选语言
	messages: {
		'zh-cn': require('./locales/zh-cn.json'),
		'en-us': require('./locales/en-us.json')
	}
})

import { saveAs } from 'file-saver'


Vue.config.productionTip = false

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js